export default __webpack_public_path__ + "static/media/Icon11.9ec9c723.svg";